import React from "react";
import clsx from "clsx";

import * as styles from "./styles.module.scss";

export type ContentsHeadingProps = {
  noContainer?: boolean;
  id: number;
  title: string;
};

const ContentsHeading: React.FC<ContentsHeadingProps> = ({ id, noContainer, title }) => {
  const className = clsx(styles.contentsHeading, noContainer && styles.noContainer, "contentsHeadingTitle");
  const uid = `${id}-${title.replace(/\s/g, "-").toLowerCase()}`;
  return noContainer ? (
    <div className={className}>
      <h2 id={uid}>
        {id}. {title}
      </h2>
    </div>
  ) : (
    <div className={className}>
      <div className="container small contentsHeadingTitle">
        <h2 id={uid}>
          {id}. {title}
        </h2>
      </div>
    </div>
  );
};

export default ContentsHeading;
